import moment from "moment";

export const generateAgencyOptions = requests => {
  if (!requests.length) return [];

  const uniqueAgencies = [
    ...new Set(requests.map(request => request.agency_name).filter(Boolean))
  ];

  return uniqueAgencies.sort().map(agencyName => ({
    value: agencyName,
    label: agencyName
  }));
};

export const generateDateRangeOptions = requests => {
  if (!requests.length) return [];

  const earliest = moment.min(requests.map(r => moment(r.created_at)));
  const now = moment();
  const options = [];

  const current = earliest.clone().startOf("quarter");
  while (current.isSameOrBefore(now, "quarter")) {
    const quarterKey = `${current.year()}-Q${current.quarter()}`;
    options.push({
      value: quarterKey,
      label: `${current
        .clone()
        .startOf("quarter")
        .format("MM/DD/YY")} - ${current
        .clone()
        .endOf("quarter")
        .format("MM/DD/YY")}`
    });
    current.add(1, "quarter");
  }

  return options.reverse();
};
